import React, { useState, useRef, useEffect, useCallback, useContext, useMemo } from "react";
import { Table, Form, Modal, Button, Alert } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaDownload, FaTrash, FaUpload, FaEdit } from "react-icons/fa";
import Papa from "papaparse";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import { statusColor } from "../../utils/statusColor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pdfimage from "../images/pdf_downlaod.png";
import { BASE_URL } from "../../api/api";
import Swal from "sweetalert2";
import { AuthContext } from "../../context/AuthContext";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
const VendorBatchPage = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const fileInputRef = useRef();
  const modalFileInputRef = useRef();

  const { selectedInvoices = [], vendorName = "", vendorId = '', isgstRegistered, isExcelUpload = false } = location.state || {};
  console.log(selectedInvoices, 'sllslslsl')

  // State declarations
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  // const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [previousInvoices, setPreviousInvoices] = useState([]);
  const [fileType, setFileType] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceExists, setInvoiceExists] = useState(false);
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(new Date().toISOString().split("T")[0]);
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    uploadedFile: false,
    remarks: {},
  });
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [editedCharges, setEditedCharges] = useState({
    repairCharges: "0.00",
    serviceCharges: "0.00",
    remarks: "",
    file: null, billingType: "billing",
    fileName: "",
  });
  const [isGSTApplied, setIsGSTApplied] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);

  const [modalClaimData, setModalClaimData] = useState(null);
  const [activePreviewTab, setActivePreviewTab] = useState("challan");

  const [isNoDisabled, setIsNoDisabled] = useState(false);
  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState(null);
  const [remarks, setRemarks] = useState("");
  const [remarkFile, setRemarkFile] = useState(null);
  useEffect(() => {
    if (isgstRegistered?.toLowerCase() === "yes") {
      setIsGSTApplied(true);
      setIsNoDisabled(true);
    } else {
      setIsGSTApplied(false);
      setIsNoDisabled(false);
    }
  }, [isgstRegistered]);

  useEffect(() => {
    const saved = sessionStorage.getItem("editedInvoice");
    if (saved) {
      const edited = JSON.parse(saved);
      setInvoices((prev) => {
        const updated = [...prev];
        const index = updated.findIndex(
          (inv) => inv.aA_Number === edited.aA_Number
        );
        if (index !== -1) {
          updated[index] = { ...updated[index], ...edited };
        }
        return updated;
      });
      sessionStorage.removeItem("editedInvoice");
    }
  }, []);

  // Initialize invoices from selectedInvoices
  // Initialize invoices from selectedInvoices
  // Initialize invoices from selectedInvoices
  useEffect(() => {
    const storedInvoicesRaw = localStorage.getItem("invoices");
    let storedInvoices = [];
    try {
      if (storedInvoicesRaw) storedInvoices = JSON.parse(storedInvoicesRaw);
    } catch (e) {
      console.error("Error parsing stored invoices", e);
    }

    const initializedInvoices = selectedInvoices.map((invoice) => {
      const existing = storedInvoices.find((item) => item.aA_Number === invoice.aA_Number);
      return {
        ...invoice,
        isChecked: invoice.isChecked !== undefined ? invoice.isChecked : true,
        remarks: existing?.remarks || invoice.remarks || "",
        remarkFile: existing?.remarkFile || null,
        RemarkFile: existing?.RemarkFile || null,
        remarkFileUrl: existing?.remarkFileUrl || invoice.remarkFileUrl || null,
        documentFileUrl: existing?.documentFileUrl || invoice.documentFileUrl || null,
        billingType: existing?.billingType || invoice.billingType || "billing",
        isEdited: existing?.isEdited || false,
        repairCharges: existing?.repairCharges || (invoice.repairCharges
          ? parseFloat(invoice.repairCharges).toFixed(2)
          : "0.00"),
        serviceCharges: existing?.serviceCharges || (invoice.serviceCharges
          ? parseFloat(invoice.serviceCharges).toFixed(2)
          : "0.00"),
        total: existing?.total || (invoice.total
          ? parseFloat(invoice.total).toFixed(2)
          : (
            parseFloat(invoice.repairCharges || 0) +
            parseFloat(invoice.serviceCharges || 0)
          ).toFixed(2)),
      };
    });
    setInvoices(initializedInvoices);
  }, [selectedInvoices]);

  useEffect(() => {
    if (vendorId && !invoiceNo) {
      fetchInvoiceNumber();
    }
  }, [vendorId, invoiceNo]);

  const numberToWords = (num) => {
    const a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';
    let str = '';
    str += parseInt(n[1]) !== 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += parseInt(n[2]) !== 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += parseInt(n[3]) !== 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += parseInt(n[4]) !== 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += parseInt(n[5]) !== 0 ? ((str !== '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.trim() ? str.trim() + ' Rupees Only' : 'Zero Rupees Only';
  };

  const getHsnSac = (materialName) => {
    const name = (materialName || "").toUpperCase();
    if (name.includes("DISPLAY")) return "85177990";
    if (name.includes("FRAME")) return "85177990";
    if (name.includes("BATTERY")) return "39269099";
    if (name.includes("COVER")) return "39269099";
    if (name.includes("STICKER")) return "48239090";
    if (name.includes("SERVICE") || name.includes("LOGISTIC")) return "998716";
    return "85177990"; // default fallback HSN
  };

  const getVendorDetails = (vendorName, state) => {
    const defaults = {
      name: vendorName || "Chitransh Enterprises",
      address: "1685, Shyam Nath Tiwari Ki Gali, Choura Rasta, Jaipur",
      phone: "9460871655",
      gstin: "08AUMPB7316G1ZO",
      state: "08-Rajasthan"
    };

    const nameUpper = (vendorName || "").toUpperCase();
    if (nameUpper.includes("CHITRANSH")) {
      return defaults;
    } else if (nameUpper.includes("NPD")) {
      return {
        name: "NPD Enterprises - Meerut",
        address: "Meerut Road, Near Bypass, Meerut",
        phone: "9837011777",
        gstin: "09AUMPB7316G1ZO",
        state: "09-Uttar Pradesh"
      };
    }

    const stateStr = state || "Rajasthan";
    const stateCode = stateStr.toUpperCase().includes("UTTAR PRADESH") ? "09" : "08";
    return {
      name: vendorName || "Chitransh Enterprises",
      address: stateStr + ", India",
      phone: "9460871655",
      gstin: `${stateCode}AUMPB7316G1ZO`,
      state: `${stateCode}-${stateStr}`
    };
  };

  const getDisplayItems = () => {
    const inputRepair = parseFloat(editedCharges.repairCharges) || 0;
    const inputService = parseFloat(editedCharges.serviceCharges) || 0;

    const formattedRepairParts = [];
    if (inputRepair > 0) {
      formattedRepairParts.push({
        name: "Repair Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputRepair,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputRepair * 0.18 : 0,
        amount: isGSTApplied ? inputRepair * 1.18 : inputRepair
      });
    }

    const formattedServiceParts = [];
    if (inputService > 0) {
      formattedServiceParts.push({
        name: "Logistic Charges",
        hsn: "",
        quantity: 1,
        unit: "Pcs",
        price: inputService,
        gstRate: 18,
        gstAmount: isGSTApplied ? inputService * 0.18 : 0,
        amount: isGSTApplied ? inputService * 1.18 : inputService
      });
    }

    return {
      repair: formattedRepairParts,
      service: formattedServiceParts
    };
  };

  const downloadChallanPDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    const doc = externalDoc || new jsPDF();
    const vendor = getVendorDetails(vendorName || invoice?.sellingPartner, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const currentInvoiceNo = invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Challan", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Challan Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${currentInvoiceNo}`, 130, 67);
    doc.text(`Date : ${currentInvoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      "Rs. " + parseFloat(item.price * item.quantity).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalWithGST = subTotal; // Challan does not have GST

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 80 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 20 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections: Left (Details, Words, Terms) and Right (Totals box)
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Reset Text Color
    doc.setTextColor(0, 0, 0);

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Challan_${aaNumber}.pdf`);
    }
    return doc;
  };

  const downloadInvoicePDF = (invoice, itemsData, shouldSave = true, externalDoc = null) => {
    const doc = externalDoc || new jsPDF();
    const vendor = getVendorDetails(vendorName || invoice?.sellingPartner, modalClaimData?.ascState);
    const customerName = invoice?.customerName || "Customer";
    const aaNumber = invoice?.aA_Number || "";
    const imei = invoice?.imeiNumber || "";
    const device = `${invoice?.brand || ""} ${invoice?.makeModel || ""}`;
    const currentInvoiceNo = invoiceNo || `AA/CE/${invoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    const customerAddress = modalClaimData?.address || "Address Not Found";
    const customerPincode = modalClaimData?.pincode || "";

    // 1. Header
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.text(vendor.name, 15, 20);

    doc.setFont("Helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(80, 80, 80);
    doc.text(vendor.address, 15, 25);
    doc.text(`Phone no. : ${vendor.phone}`, 15, 30);
    doc.text(`GSTIN : ${vendor.gstin}`, 15, 35);
    doc.text(`State: ${vendor.state}`, 15, 40);

    // Horizontal Line
    doc.setDrawColor(220, 220, 220);
    doc.setLineWidth(0.5);
    doc.line(15, 45, 195, 45);

    // 2. Title
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(114, 28, 36); // Maroon color
    doc.text("Tax Invoice", 105, 53, { align: "center" });

    // 3. Columns: To & Details
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("Helvetica", "bold");
    doc.text("Bill To", 15, 62);
    doc.text("Across Assist Pvt Ltd c/o " + customerName + " (" + aaNumber + ")", 15, 67);

    doc.setFont("Helvetica", "normal");
    const addrLines = doc.splitTextToSize(customerAddress + (customerPincode ? `\nPin Code - ${customerPincode}` : "") + "\nGST IN: 06AAHCB4822B1Z6", 90);
    doc.text(addrLines, 15, 72);

    // Right Column
    doc.setFont("Helvetica", "bold");
    doc.text("Invoice Details", 130, 62);
    doc.setFont("Helvetica", "normal");
    doc.text(`No. : ${currentInvoiceNo}`, 130, 67);
    doc.text(`Date : ${currentInvoiceDate}`, 130, 72);

    // 4. Table Rows
    const tableBody = itemsData.map((item, idx) => [
      idx + 1,
      item.name,
      item.quantity,
      item.unit,
      "Rs. " + parseFloat(item.price).toFixed(2),
      `Rs. ${parseFloat(item.gstAmount).toFixed(2)} (${item.gstRate}%)`,
      "Rs. " + parseFloat(item.amount).toFixed(2)
    ]);

    const totalQty = itemsData.reduce((sum, item) => sum + item.quantity, 0);
    const subTotal = itemsData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalGst = itemsData.reduce((sum, item) => sum + item.gstAmount, 0);
    const totalWithGST = itemsData.reduce((sum, item) => sum + item.amount, 0);

    // Add total row
    tableBody.push([
      { content: "Total", colSpan: 2, styles: { fontStyle: "bold", halign: "left" } },
      { content: totalQty.toString(), styles: { fontStyle: "bold", halign: "center" } },
      "",
      "",
      "",
      { content: "Rs. " + totalWithGST.toFixed(2), styles: { fontStyle: "bold", halign: "right" } }
    ]);

    // Draw Table
    autoTable(doc, {
      startY: 95,
      head: [["#", "Item name", "Quantity", "Unit", "Price/ Unit", "GST", "Amount"]],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [92, 37, 24],
        textColor: [255, 255, 255],
        fontStyle: "bold",
        fontSize: 8,
        halign: "center"
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 70 },
        2: { halign: "center", cellWidth: 20 },
        3: { halign: "center", cellWidth: 15 },
        4: { halign: "right", cellWidth: 22 },
        5: { halign: "center", cellWidth: 26 },
        6: { halign: "right", cellWidth: 22 }
      },
      styles: {
        fontSize: 8,
        cellPadding: 3
      },
      didParseCell: function (data) {
        if (data.row.index === tableBody.length - 1) {
          data.cell.styles.fillColor = [245, 245, 245];
        }
      }
    });

    const finalY = doc.lastAutoTable.finalY + 10;

    // 5. Bottom Sections
    let currY = finalY;
    doc.setFont("Helvetica", "bold");
    doc.text("Description", 15, currY);
    doc.setFont("Helvetica", "normal");
    currY += 5;
    doc.text(`Repair support for ${device}`, 15, currY);
    doc.text(`IMEI: ${imei}`, 15, currY + 4);

    doc.setFont("Helvetica", "bold");
    doc.text("Amount In Words", 15, currY + 12);
    doc.setFont("Helvetica", "normal");
    const roundedTotal = Math.round(totalWithGST);
    doc.text(numberToWords(roundedTotal), 15, currY + 17);

    doc.setFont("Helvetica", "bold");
    doc.text("Terms and Conditions", 15, currY + 25);
    doc.setFont("Helvetica", "normal");
    doc.text("1. E.&O.E.", 15, currY + 30);

    // Right Section: Summary Box
    const boxX = 125;
    const boxWidth = 70;
    let boxY = finalY;

    // Subtotal Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.setFont("Helvetica", "normal");
    doc.text("Sub Total", boxX + 5, boxY + 5);
    doc.text("Rs. " + subTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // IGST Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text(`IGST@18%`, boxX + 5, boxY + 5);
    doc.text("Rs. " + totalGst.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Roundoff Row
    const roundOffVal = roundedTotal - totalWithGST;
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Round off", boxX + 5, boxY + 5);
    doc.text((roundOffVal >= 0 ? "+ " : "- ") + "Rs. " + Math.abs(roundOffVal).toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Total Row (Maroon Banner)
    doc.setFillColor(92, 37, 24);
    doc.rect(boxX, boxY, boxWidth, 8, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("Helvetica", "bold");
    doc.text("Total", boxX + 5, boxY + 5.5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5.5, { align: "right" });

    // Received Row
    boxY += 8;
    doc.setTextColor(0, 0, 0);
    doc.setFont("Helvetica", "normal");
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Received", boxX + 5, boxY + 5);
    doc.text("Rs. 0.00", boxX + boxWidth - 5, boxY + 5, { align: "right" });
    boxY += 7;

    // Balance Row
    doc.rect(boxX, boxY, boxWidth, 7);
    doc.text("Balance", boxX + 5, boxY + 5);
    doc.text("Rs. " + roundedTotal.toFixed(2), boxX + boxWidth - 5, boxY + 5, { align: "right" });

    // Signature Area
    let sigY = boxY + 18;
    doc.setFont("Helvetica", "normal");
    doc.setFontSize(8);
    doc.text(`For : ${vendor.name}`, boxX + 5, sigY);

    // Draw Stamp
    const stampX = boxX + boxWidth / 2 - 10;
    const stampY = sigY + 12;
    doc.setDrawColor(0, 51, 153);
    doc.setLineWidth(0.8);
    doc.circle(stampX, stampY, 12);

    doc.setTextColor(0, 51, 153);
    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("CHITRANSH", stampX, stampY - 3, { align: "center" });

    doc.setFontSize(7);
    doc.setFont("Helvetica", "oblique");
    doc.text("Honey", stampX, stampY + 1, { align: "center" });

    doc.setFontSize(5);
    doc.setFont("Helvetica", "bold");
    doc.text("ENTERPRISES", stampX, stampY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("Helvetica", "bold");
    doc.text("Authorized Signatory", boxX + 5, sigY + 28);

    if (shouldSave) {
      doc.save(`Invoice_${aaNumber}.pdf`);
    }
    return doc;
  };

  const renderDocumentPreview = () => {
    if (!editingInvoice) return null;

    const displayItems = getDisplayItems();
    const vendor = getVendorDetails(vendorName || editingInvoice?.sellingPartner, modalClaimData?.ascState);
    const currentInvoiceNo = invoiceNo || `AA/CE/${editingInvoice?.id || 1}`;
    const currentInvoiceDate = invoiceDate
      ? new Date(invoiceDate).toLocaleDateString('en-GB').replace(/\//g, '-')
      : new Date().toLocaleDateString('en-GB').replace(/\//g, '-');

    // Choose document type based on Billing Type and active preview tab
    let previewTitle = "Tax Invoice";
    let itemsToRender = [];
    let showGstCol = true;
    let isChallanDoc = false;

    if (editedCharges.billingType === "billing") {
      previewTitle = "Tax Invoice";
      itemsToRender = [...displayItems.repair, ...displayItems.service];
      showGstCol = true;
      isChallanDoc = false;
    } else {
      if (activePreviewTab === "challan") {
        previewTitle = "Challan";
        itemsToRender = displayItems.repair;
        showGstCol = false;
        isChallanDoc = true;
      } else {
        previewTitle = "Tax Invoice";
        itemsToRender = displayItems.service;
        showGstCol = true;
        isChallanDoc = false;
      }
    }

    const previewTotalQty = itemsToRender.reduce((sum, item) => sum + item.quantity, 0);
    const previewSubTotal = itemsToRender.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const previewTotalGst = isChallanDoc ? 0 : itemsToRender.reduce((sum, item) => sum + item.gstAmount, 0);
    const previewTotalWithGST = isChallanDoc ? previewSubTotal : itemsToRender.reduce((sum, item) => sum + item.amount, 0);
    const previewRoundedTotal = Math.round(previewTotalWithGST);
    const previewRoundOff = previewRoundedTotal - previewTotalWithGST;
    const previewAmountInWords = numberToWords(previewRoundedTotal);

    return (
      <div className="invoice-preview-container bg-white border rounded p-3 shadow-sm" style={{ fontSize: "11px", color: "#333", fontFamily: "Arial, sans-serif" }}>
        {/* Document Header */}
        <div className="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
          <div>
            <h6 className="fw-bold m-0" style={{ fontSize: "14px", color: "#000" }}>{vendor.name}</h6>
            <div className="text-muted" style={{ fontSize: "10px", lineHeight: "1.3" }}>
              {vendor.address}<br />
              Phone no. : {vendor.phone}<br />
              GSTIN : {vendor.gstin}<br />
              State: {vendor.state}
            </div>
          </div>
        </div>

        {/* Title */}
        <div className="text-center my-2">
          <h6 className="fw-bold m-0" style={{ color: "#721c24", textTransform: "uppercase", letterSpacing: "1px", fontSize: "13px" }}>
            {previewTitle}
          </h6>
        </div>

        {/* To and Details */}
        <div className="row mb-3">
          <div className="col-7">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "To" : "Bill To"}</span>
            <span className="fw-bold text-dark d-block">
              Across Assist Pvt Ltd c/o {editingInvoice.customerName} ({editingInvoice.aA_Number})
            </span>
            <span className="text-muted d-block" style={{ lineHeight: "1.3" }}>
              {modalClaimData?.address || "Address Not Found"}<br />
              {modalClaimData?.pincode && `Pin Code - ${modalClaimData.pincode}`}<br />
              GST IN: 06AAHCB4822B1Z6
            </span>
          </div>
          <div className="col-5 text-end">
            <span className="fw-bold d-block text-dark" style={{ fontSize: "10px" }}>{isChallanDoc ? "Challan Details" : "Invoice Details"}</span>
            <span className="text-dark d-block">No. : <strong className="text-dark">{currentInvoiceNo}</strong></span>
            <span className="text-dark d-block">Date : {currentInvoiceDate}</span>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive mb-3">
          <table className="table table-bordered table-sm m-0 text-center" style={{ fontSize: "10px" }}>
            <thead>
              <tr style={{ backgroundColor: "#5C2518", color: "#ffffff" }}>
                <th style={{ width: "5%" }}>#</th>
                <th style={{ width: showGstCol ? "50%" : "65%", textAlign: "left" }}>Item name</th>
                <th style={{ width: "10%" }}>Qty</th>
                <th style={{ width: "10%" }}>Unit</th>
                <th style={{ width: "13%", textAlign: "right" }}>Price/ Unit</th>
                {showGstCol && <th style={{ width: "15%", textAlign: "right" }}>GST</th>}
                <th style={{ width: "12%", textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {itemsToRender.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td style={{ textAlign: "left" }}>{item.name}</td>
                  <td>{item.quantity}</td>
                  <td>{item.unit}</td>
                  <td style={{ textAlign: "right" }}>₹{item.price.toFixed(2)}</td>
                  {showGstCol && (
                    <td style={{ textAlign: "right" }}>
                      ₹{item.gstAmount.toFixed(2)} <span className="text-muted" style={{ fontSize: "9px" }}>({item.gstRate}%)</span>
                    </td>
                  )}
                  <td style={{ textAlign: "right" }}>
                    ₹{(isChallanDoc ? item.price : item.amount).toFixed(2)}
                  </td>
                </tr>
              ))}
              {/* Total Row */}
              <tr className="fw-bold bg-light">
                <td colSpan="2" style={{ textAlign: "left" }}>Total</td>
                <td>{previewTotalQty}</td>
                <td></td>
                <td></td>
                {showGstCol && <td></td>}
                <td style={{ textAlign: "right" }}>₹{previewTotalWithGST.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer Summary Blocks */}
        <div className="row pt-2 border-top">
          {/* Left Block */}
          <div className="col-7">
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Description</span>
              <span className="text-muted d-block">
                Repair support for {editingInvoice.brand} {editingInvoice.makeModel}<br />
                IMEI: {editingInvoice.imeiNumber}
              </span>
            </div>
            <div className="mb-2">
              <span className="fw-bold text-dark d-block">Amount In Words</span>
              <span className="text-muted d-block fw-semibold text-wrap" style={{ fontSize: "9.5px" }}>
                {previewAmountInWords}
              </span>
            </div>
            <div>
              <span className="fw-bold text-dark d-block">Terms and Conditions</span>
              <span className="text-muted d-block">1. E.&O.E.</span>
            </div>
          </div>

          {/* Right Block */}
          <div className="col-5 text-end">
            <div className="border rounded mb-3 bg-light text-start">
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Sub Total</span>
                <span>₹{previewSubTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <div className="d-flex justify-content-between p-1 border-bottom">
                  <span>IGST@18%</span>
                  <span>₹{previewTotalGst.toFixed(2)}</span>
                </div>
              )}
              <div className="d-flex justify-content-between p-1 border-bottom">
                <span>Round off</span>
                <span>{previewRoundOff >= 0 ? "+" : ""}{previewRoundOff.toFixed(2)}</span>
              </div>
              <div className="d-flex justify-content-between p-1 fw-bold text-white" style={{ backgroundColor: "#5C2518" }}>
                <span>Total</span>
                <span>₹{previewRoundedTotal.toFixed(2)}</span>
              </div>
              {!isChallanDoc && (
                <>
                  <div className="d-flex justify-content-between p-1 border-bottom">
                    <span>Received</span>
                    <span>₹0.00</span>
                  </div>
                  <div className="d-flex justify-content-between p-1 fw-bold">
                    <span>Balance</span>
                    <span>₹{previewRoundedTotal.toFixed(2)}</span>
                  </div>
                </>
              )}
            </div>

            {/* Signature Area */}
            <div className="text-center pt-2 relative" style={{ minHeight: "100px" }}>
              <span className="text-muted d-block mb-1" style={{ fontSize: "9px" }}>For : {vendor.name}</span>

              <div
                className="d-inline-flex flex-column align-items-center justify-content-center rounded-circle border border-primary p-1"
                style={{
                  width: "56px",
                  height: "56px",
                  borderColor: "#003399",
                  borderStyle: "solid",
                  borderWidth: "1.5px",
                  transform: "rotate(-12deg)",
                  color: "#003399",
                  margin: "5px 0",
                  opacity: 0.85,
                  userSelect: "none"
                }}
              >
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>CHITRANSH</span>
                <span style={{ fontSize: "9px", fontFamily: "cursive", fontWeight: "bold", fontStyle: "italic", margin: "-2px 0" }}>Honey</span>
                <span style={{ fontSize: "5px", fontWeight: "bold" }}>ENTERPRISES</span>
              </div>

              <span className="fw-bold text-dark d-block mt-2" style={{ fontSize: "9.5px" }}>Authorized Signatory</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Constants
  const itemsPerPage = 10;
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirstItem, indexOfLastItem);
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);
  const totalRepairCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const grossAmount = totalRepairCharges + totalServiceCharges;

  const finalAmount = isGSTApplied
    ? (grossAmount + parseFloat(gstAmount)).toFixed(2)
    : grossAmount.toFixed(2);

  const totalservicechargewithGST = (totalServiceCharges + parseFloat(gstAmount)).toFixed(2);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every(
      (item, index) => item.aA_Number === arr2[index].aA_Number
    );
  };
  useEffect(() => {
    if (currentInvoices.length === 0) return;

    if (!areArraysEqual(currentInvoices, previousInvoices)) {
      setLoading(true);
      const aaNumbers = currentInvoices
        .map((invoice) => invoice.aA_Number)
        .join(",");

      fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNumbers}`)
        .then((response) => response.json())
        .then((responseData) => {
          if (Array.isArray(responseData.dataItems)) {
            setApiData([...responseData.dataItems]);

            // Update invoices with API data for remarks, remarkFileUrl, documentFileUrl, and billingType
            setInvoices(prevInvoices => {
              return prevInvoices.map(invoice => {
                const apiInvoice = responseData.dataItems.find(
                  item => item.aA_Number === invoice.aA_Number
                );
                if (apiInvoice) {
                  return {
                    ...invoice,
                    remarks: apiInvoice.remarks || invoice.remarks,
                    remarkFileUrl: apiInvoice.remarkFileUrl || invoice.remarkFileUrl,
                    documentFileUrl: apiInvoice.documentFileUrl || invoice.documentFileUrl,
                    billingType: apiInvoice.billingType || invoice.billingType,
                  };
                }
                return invoice;
              });
            });
          } else {
            setApiData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching API data:", error);
          setApiData([]);
        })
        .finally(() => setLoading(false));

      setPreviousInvoices(currentInvoices);
    }
  }, [currentInvoices, previousInvoices]);
  const mergedInvoices = currentInvoices.map((invoice) => {
    if (!isExcelUpload) return invoice;

    const apiRow = apiData.find((row) => row.aA_Number === invoice.aA_Number);

    if (!apiRow) return invoice;

    return {
      ...invoice,
      creationDate: apiRow.creationDate || invoice.creationDate,
      closureDate: apiRow.closureDate || invoice.closureDate,
      sellingPartner: apiRow.sellingPartner || invoice.sellingPartner,
      remarks: apiRow.remarks || invoice.remarks, // Include API remarks
      remarkFileUrl: apiRow.remarkFileUrl || invoice.remarkFileUrl, // Include API remarkFileUrl
    };
  });

  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();

  //  ----------------9 july----------------
  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData) || apiData.length === 0) return "row-red";

      const matchedData = apiData.find(
        (item) => item.aA_Number === invoice.aA_Number
      );

      if (!matchedData) return "row-red";

      const normalizedIMEI = normalize(invoice.imeiNumber || "");
      const imeiCount = currentInvoices.filter(
        (inv) => normalize(inv.imeiNumber || "") === normalizedIMEI
      ).length;

      // Red if IMEI is missing or repeated
      if (!normalizedIMEI || imeiCount > 1) return "row-red";

      const isServiceTypeMismatch =
        normalize(matchedData.serviceType) !== normalize(invoice.serviceType);
      const isRepairChargesMismatch =
        parseFloat(matchedData.repairCharges || 0).toFixed(2) !==
        parseFloat(invoice.repairCharges || 0).toFixed(2);
      const isServiceChargesMismatch =
        parseFloat(matchedData.serviceCharges || 0).toFixed(2) !==
        parseFloat(invoice.serviceCharges || 0).toFixed(2);
      // const isSellingPartnerMismatch =
      //   normalize(matchedData.sellingPartner || "") !==
      //   normalize(invoice.sellingPartner || "");
      const isTotalMismatch =
        parseFloat(matchedData.total || 0).toFixed(2) !==
        parseFloat(invoice.total || 0).toFixed(2);
      const isIMEIMismatch =
        normalize(matchedData.imeiNumber || "") !== normalizedIMEI;

      if (!normalizedIMEI || imeiCount > 1 || isIMEIMismatch) return "row-red";

      if (
        isServiceTypeMismatch ||
        isRepairChargesMismatch ||
        isServiceChargesMismatch ||
        // isSellingPartnerMismatch ||
        isTotalMismatch
      ) {
        return "row-yellow";
      }

      return "row-green";
    },
    [apiData, currentInvoices]
  );

  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item.aA_Number === invoice.aA_Number
    );
    if (!matchedData)
      return [
        { field: "AA Number", table: invoice.aA_Number, api: "Not Found" },
      ];

    const differences = [];

    // if (normalize(matchedData.serviceType) !== normalize(invoice.serviceType)) {
    //   differences.push({
    //     field: "Service Type",
    //     table: invoice.serviceType || "-",
    //     api: matchedData.serviceType || "-",
    //   });
    // }
    if (
      parseFloat(matchedData.repairCharges || 0).toFixed(2) !==
      parseFloat(invoice.repairCharges || 0).toFixed(2)
    ) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "-",
        api: matchedData.repairCharges || "-",
      });
    }
    if (
      parseFloat(matchedData.serviceCharges || 0).toFixed(2) !==
      parseFloat(invoice.serviceCharges || 0).toFixed(2)
    ) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "-",
        api: matchedData.serviceCharges || "-",
      });
    }
    // if (
    //   normalize(matchedData.sellingPartner || "") !==
    //   normalize(invoice.sellingPartner || "")
    // ) {
    //   differences.push({
    //     field: "Selling Partner",
    //     table: invoice.sellingPartner || "-",
    //     api: matchedData.sellingPartner || "-",
    //   });
    // }
    if (
      parseFloat(matchedData.total || 0).toFixed(2) !==
      parseFloat(invoice.total || 0).toFixed(2)
    ) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "-",
        api: matchedData.total || "-",
      });
    }
    if (
      normalize(matchedData.imeiNumber || "") !==
      normalize(invoice.imeiNumber || "")
    ) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "-",
        api: matchedData.imeiNumber || "-",
      });
    }

    return differences.length > 0 ? differences : [];
  };
  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prev) =>
      prev.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      )
    );
  };

  const handleRemarkSubmit = async () => {
    try {
      const editingInvoice = invoices[selectedInvoiceIndex];
      const remarkFormData = new FormData();
      remarkFormData.append("AANo", editingInvoice.aA_Number);
      remarkFormData.append("Remark", `${editingInvoice.aA_Number} - ${remarks}`);
      remarkFormData.append("BatchNo", "");
      remarkFormData.append("ByWhom", user?.role || "");

      if (remarkFile instanceof File) {
        remarkFormData.append("RemarkFile", remarkFile, remarkFile.name);
      }

      const response = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
        method: "POST",
        body: remarkFormData,
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to update batch remarks.");
      }

      const updatedInvoices = invoices.filter((_, i) => i !== selectedInvoiceIndex);
      setInvoices(updatedInvoices);

      Swal.fire("Deleted!", "Selected records have been deleted.", "success");

      // if (updatedInvoices.length === 0) {
      //   navigate("/");
      // }

      // reset modal fields
      setOpenRemarkModal(false);
      setRemarks("");
      setRemarkFile(null);
    } catch (error) {
      console.error("Error updating batch remarks:", error);
      toast.error(`Failed to update batch remarks: ${error.message}`);
    }
  };
  const handleDelete = async (aANumber) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Step 1: Ask for Remark Input (Commented out)
        // const { value: remark } = await Swal.fire({
        //   title: "Add Remark",
        //   input: "textarea",
        //   inputLabel: "Please enter your remark before deleting:",
        //   inputPlaceholder: "Enter remark here...",
        //   inputAttributes: { "aria-label": "Type your remark here" },
        //   showCancelButton: true,
        //   confirmButtonText: "Save Remark",
        // });
        // 
        // if (!remark) {
        //   Swal.fire("Cancelled", "Remark is required to proceed.", "info");
        //   return;
        // }

        try {
          // Commented out InsertLogsAndRemarksTracking
          // const allAANumbers = invoices.map((inv) => inv.aA_Number).join(",");
          // 
          // const formData = new FormData();
          // formData.append("aA_Number", allAANumbers);
          // formData.append("remarks", `AANumber-${aANumber} Deleted: ${remark}`);
          // formData.append("remarkAndLogBy", user.role);
          // formData.append("batchNo", null);
          // formData.append("logs", `AANumber-${aANumber} Deleted`);
          // formData.append("DeletedAA", aANumber);
          // 
          // 
          // const remarkRes = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
          //   method: "POST",
          //   body: formData,
          // });
          // if (!remarkRes.ok) {
          //   throw new Error("Failed to save remark");
          // }

          // Step 3: Call Delete API directly after confirm
          const deleteResponse = await fetch(`${BASE_URL}/ResetGadgetCaseDetails`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ aA_Number: aANumber }),
          });

          const data = await deleteResponse.json();

          if (deleteResponse.ok) {
            const updatedInvoices = invoices.filter((invoice) => invoice.aA_Number !== aANumber);
            setInvoices(updatedInvoices);

            Swal.fire("Deleted!", "Your record has been deleted.", "success");

            if (updatedInvoices.length === 0) {
              navigate("/invoice");
            }
          } else {
            Swal.fire("Error!", data.message || "Failed to delete record.", "error");
          }
        } catch (error) {
          console.error("Error:", error);
          Swal.fire("Error!", "Something went wrong. Please try again.", "error");
        }
      }
    });
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  // ------------------22july---------------
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["pdf", "jpg", "jpeg", "png"];
    const extension = file.name.split(".").pop().toLowerCase();

    if (!allowedTypes.includes(extension)) {
      toast.error("Only PDF, JPG, and PNG files are allowed.");
      return;
    }

    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, uploadedFile: false }));

    // If you still want CSV parsing logic for something else, move it outside:
    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: async ({ data }) => {
          const row = data[0];
          setInvoiceDate(row["Invoice Date"] || "");
          setInvoiceAmount(row["Invoice Amount"] || "");
          setCaseCount(row["Case Count"] || "");

          await fetchInvoiceNumber();
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to parse CSV file.");
        },
      });
    }
  };


  const handleModalFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditedCharges((prev) => ({
        ...prev,
        file,
        fileName: file.name,
      }));
    }
  };
  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      "CreationDate",
      "ClosureDate",
      "CustomerName",
      // "ServiceType",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber ? `="${invoice.imeiNumber}"` : "",
      CreationDate: (invoice.creationDate || "").split(" ")[0],
      ClosureDate: (invoice.closureDate || "").split(" ")[0],
      customerName: invoice.customerName || "",
      // serviceType: invoice.serviceType || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const handleEditClick = async (index, invoice) => {
    setEditIndex(index);
    setEditingInvoice(invoice);
    setEditedCharges({
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      remarks: invoice.remarks || "",
      file: invoice.RemarkFile instanceof File ? invoice.RemarkFile : (invoice.remarkFile instanceof File ? invoice.remarkFile : null),
      fileName: invoice.RemarkFile && typeof invoice.RemarkFile === "object"
        ? invoice.RemarkFile.name
        : (invoice.remarkFile && typeof invoice.remarkFile === "object" ? invoice.remarkFile.name : (invoice.remarkFileUrl || invoice.remarkFile || "")),
      billingType: invoice.billingType || "billing",
    });
    setModalClaimData(null);
    setActivePreviewTab("challan");
    setShowModal(true);

    try {
      const response = await fetch(`${BASE_URL}/GetAllGadgetClaimDetails?aaNumber=${invoice.aA_Number}`);
      const resData = await response.json();
      if (resData.status && resData.dataItems && resData.dataItems.length > 0) {
        setModalClaimData(resData.dataItems[0]);
      }
    } catch (err) {
      console.error("Error fetching claim details for modal preview:", err);
    }
  };

  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);

  const handleSaveEdit = async () => {
    if (!editingInvoice) return;
    const parsedServiceCharges = parseFloat(editedCharges.serviceCharges);
    const parsedRepairCharges = parseFloat(editedCharges.repairCharges);
    const remarks = editedCharges.remarks?.trim() || "";

    if (
      isNaN(parsedServiceCharges) ||
      parsedServiceCharges < 0 ||
      isNaN(parsedRepairCharges) ||
      parsedRepairCharges < 0
    ) {
      toast.error(
        "Service Charges and Repair Charges must be valid non-negative numbers."
      );
      return;
    }

    const isYellowRow = getRowClassName(editingInvoice) === "row-yellow";
    if (isYellowRow && !remarks) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: true },
      }));
      toast.error("Remarks are required for mismatched data.");
      return;
    }

    const formattedServiceCharges = parsedServiceCharges.toFixed(2);
    const formattedRepairCharges = parsedRepairCharges.toFixed(2);
    const formattedTotal = (parsedServiceCharges + parsedRepairCharges).toFixed(2);

    try {
      const formData = new FormData();
      formData.append("AANo", editingInvoice.aA_Number);
      formData.append("Remark", `${editingInvoice.aA_Number}: ${remarks}`);
      formData.append("RemarkBy", user.role);

      if (editedCharges.file instanceof File) {
        formData.append("RemarkFile", editedCharges.file, editedCharges.file.name);
      } else {
        formData.append("RemarkFile", null);
      }

      // Generate selected PDF document as Blob
      let pdfDoc;
      let docName;
      if (editedCharges.billingType === "billing") {
        pdfDoc = downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service], false);
        docName = `Invoice_${editingInvoice.aA_Number}.pdf`;
      } else {
        pdfDoc = new jsPDF();
        downloadChallanPDF(editingInvoice, getDisplayItems().repair, false, pdfDoc);
        pdfDoc.addPage();
        downloadInvoicePDF(editingInvoice, getDisplayItems().service, false, pdfDoc);
        docName = `Challan_Invoice_${editingInvoice.aA_Number}.pdf`;
      }
      const pdfBlob = pdfDoc.output('blob');

      formData.append("BillingType", editedCharges.billingType);
      formData.append("Document", pdfBlob, docName);

      const response = await fetch(`${BASE_URL}/UpdateClaimRemarks`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || "Failed to update claim remarks.");
      }

      // Refresh the API data for this specific invoice
      const refreshResponse = await fetch(
        `${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${editingInvoice.aA_Number}`
      );

      if (refreshResponse.ok) {
        const refreshedData = await refreshResponse.json();

        if (refreshedData.dataItems && refreshedData.dataItems.length > 0) {
          const updatedApiItem = refreshedData.dataItems[0];

          // Update apiData state
          setApiData((prev) => {
            const updated = prev.map((item) =>
              item.aA_Number === editingInvoice.aA_Number
                ? {
                  ...item,
                  ...updatedApiItem,
                  remarkFileUrl: updatedApiItem.remarkFileUrl || null,
                }
                : item
            );
            return updated;
          });

          // Update invoices state with the refreshed API data
          setInvoices((prevInvoices) => {
            const updated = prevInvoices.map((invoice) =>
              invoice.aA_Number === editingInvoice.aA_Number
                ? {
                  ...invoice,
                  serviceCharges: formattedServiceCharges,
                  repairCharges: formattedRepairCharges,
                  total: formattedTotal,
                  remarks: updatedApiItem.remarks || remarks, // Use API remarks
                  billingType: editedCharges.billingType,
                  isEdited: true,
                  RemarkFile: editedCharges.file instanceof File ? editedCharges.file : null,
                  remarkFile: editedCharges.file instanceof File ? editedCharges.file : null,
                  remarkFileUrl: updatedApiItem.remarkFileUrl || null, // Use API remarkFileUrl
                  documentFileUrl: updatedApiItem.documentFileUrl || null,
                }
                : invoice
            );
            localStorage.setItem("invoices", JSON.stringify(updated));
            return updated;
          });
        }
      }

      toast.success("Claim remarks updated successfully.");

    } catch (error) {
      console.error("Error updating claim remarks:", error);
      toast.error(`Failed to update claim remarks: ${error.message}`);
    }

    // Reset modal and state
    setShowModal(false);
    setEditingInvoice(null);
    setEditedCharges({
      serviceCharges: "0.00",
      repairCharges: "0.00",
      remarks: "",
      file: null,
      billingType: "billing",
      fileName: "",
    });
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setEditIndex(null);
    setEditingInvoice(null);
    setEditedCharges({
      repairCharges: "0.00",
      serviceCharges: "0.00",
      remarks: "",
      file: null,
      billingType: "billing",
      fileName: "",
    });
    setModalClaimData(null);
    if (editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: false },
      }));
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCharges((prev) => ({ ...prev, [name]: value }));
    if (name === "remarks" && editingInvoice) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [editingInvoice.aA_Number]: !value.trim() },
      }));
    }
  };
  function parseDateFlexible(dateStr) {
    if (!dateStr) return null;

    const [datePart] = dateStr.split(" ");

    let day, month, year;

    if (datePart.includes("-")) {
      const parts = datePart.split("-").map(Number);

      if (parts[0] > 31) {
        // yyyy-MM-dd
        [year, month, day] = parts;
      } else {
        // dd-MM-yyyy
        [day, month, year] = parts;
      }
    } else {
      return null;
    }

    return new Date(year, month - 1, day);
  }

  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);

  const handleSubmit = async () => {
    try {
      const selected = invoices.filter((inv) => inv.isChecked);
      if (selected.length === 0) {
        toast.error("Please select at least one invoice.");
        return;
      }

      // Check if all invoices in the list are edited
      const unedited = invoices.filter((inv) => {
        if (inv.isEdited) return false;
        if (inv.documentFileUrl && inv.billingType && inv.billingType !== "-") {
          return false;
        }
        return true;
      });
      if (unedited.length > 0) {
        toast.error("Please edit all the AA number rows before saving and proceeding.");
        return;
      }

      if (!invoiceNo.trim()) {
        toast.error("Invoice No is generating, please wait or try again.");
        return;
      }

      if (invoiceExists) {
        toast.error("This invoice number already exists. Please generate a unique one.");
        return;
      }

      let hasRemarkError = false;
      const newErrors = {
        invoiceNo: false,
        invoiceDate: false,
        invoiceAmount: false,
        caseCount: false,
        uploadedFile: false,
        remarks: {},
      };

      selected.forEach((invoice) => {
        const isYellowRow = getRowClassName(invoice) === "row-yellow";
        const isRemarkEmpty = !invoice.remarks?.trim();
        if (isYellowRow && isRemarkEmpty) {
          newErrors.remarks[invoice.aA_Number] = true;
          hasRemarkError = true;
        } else {
          newErrors.remarks[invoice.aA_Number] = false;
        }
      });

      setFieldErrors(newErrors);

      if (hasRemarkError) {
        toast.error("Remarks are required for all yellow rows (mismatched data).");
        return;
      }

      const today = new Date().toISOString().split("T")[0];
      const maxClosureDate = selected.reduce((maxDate, invoice) => {
        const closureRaw = invoice.closureDate;
        const closure = parseDateFlexible(closureRaw);

        console.log('Raw closure:', closureRaw);
        console.log('Parsed closure:', closure);

        if (!closure || isNaN(closure.getTime())) return maxDate;
        return !maxDate || closure > maxDate ? closure : maxDate;
      }, null);

      const invoiceDt = parseDateFlexible(invoiceDate);

      if (invoiceDt && !isNaN(invoiceDt.getTime())) {
        if (maxClosureDate && invoiceDt < maxClosureDate) {
          setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
          toast.error("Invoice Date cannot be earlier than the latest Closure Date.");
          return;
        }
      } else {
        toast.error("Invalid Invoice Date.");
        return;
      }

      if (invoiceDate > today) {
        setFieldErrors((prev) => ({ ...prev, invoiceDate: true }));
        toast.error("Invoice Date cannot be a future date.");
        return;
      }

      // ----------- IMEI Logic ------------
      let imeiError = false;
      const imeiCountMap = {};

      for (const invoice of selected) {
        const normalizedIMEI = normalize(invoice.imeiNumber || "");

        if (normalizedIMEI) {
          imeiCountMap[normalizedIMEI] = (imeiCountMap[normalizedIMEI] || 0) + 1;
        }

        const matchedData = apiData.find(
          (item) => item.aA_Number === invoice.aA_Number
        );

        if (!normalizedIMEI || imeiCountMap[normalizedIMEI] > 1) {
          imeiError = true;
          alert(
            `IMEI number missing or duplicated for AA Number: ${invoice.aA_Number}`
          );
        }

        if (
          matchedData &&
          normalize(matchedData.imeiNumber || "") !== normalizedIMEI
        ) {
          imeiError = true;
          toast.error(`IMEI mismatch for AA Number: ${invoice.aA_Number}`);
        }
      }

      if (imeiError) {
        toast.error("Please fix IMEI errors before submitting.");
        return;
      }

      // ----------- Mismatch Logic ------------
      let hasMismatch = false;
      for (const invoice of selected) {
        const matchedData = apiData.find(
          (item) => item.aA_Number === invoice.aA_Number
        );

        if (!matchedData) {
          console.warn(
            `AA Number ${invoice.aA_Number} not found in reference data. Proceeding anyway.`
          );
          continue; // Skip mismatch check for this entry
        }

        if (
          normalize(matchedData.serviceType) !== normalize(invoice.serviceType) ||
          normalize(matchedData.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(matchedData.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(matchedData.total) !== normalize(invoice.total)
        ) {
          hasMismatch = true;
        }
      }

      if (hasMismatch) {
        const confirmProceed = window.confirm(
          "Warning: Some invoice fields do not match the original data. Do you want to proceed anyway?"
        );
        if (!confirmProceed) return;
      }

      // ----------- Prepare FormData ------------
      const formData = new FormData();
      const extract = (key) =>
        selected.map((item) => item[key] || "").join(", ");
      formData.append("AANo", extract("aA_Number"));
      formData.append("IMEINo", extract("imeiNumber"));
      // formData.append("CreationDate", extract("creationDate"));
      // formData.append("ClosureDate", extract("closureDate"));
      // formData.append(
      //   "CreationDate",
      //   new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " 00:00:00"
      // );
      // formData.append(
      //   "ClosureDate",
      //   new Date().toLocaleDateString("en-GB").replace(/\//g, "-") + " 00:00:00"
      // );

      formData.append("CustomerName", extract("customerName"));
      formData.append("CreationDate", extract("creationDate"));
      formData.append("ClosureDate", extract("closureDate"));
      const isNetworkRole = user?.role === "NetworkAdmin" || user?.role === "NetworkSubAdmin";
      const finalVendorName = isNetworkRole ? `${vendorName} (Network)` : vendorName;
      formData.append("VendorName", finalVendorName);
      formData.append("FinalAmount", finalAmount);
      formData.append("TotalRepairCharges", totalRepairCharges.toFixed(2));
      formData.append("TotalServiceCharges", totalservicechargewithGST);
      formData.append("ServiceType", extract("serviceType"));
      formData.append("Brand", extract("brand"));
      formData.append("MakeModel", extract("makeModel"));
      formData.append("RepairCharges", extract("repairCharges"));
      formData.append("ServiceCharges", extract("serviceCharges"));
      formData.append("GST", gstAmount || "");
      formData.append("Total", extract("total"));
      formData.append("SellingPartner", extract("sellingPartner") || "");
      formData.append("Remarks", extract("remarks"));
      // formData.append(
      //   "InvoiceStatus",
      //   uploadedFile ? "Invoice Uploaded" : "No Invoice Uploaded"
      // );
      formData.append("InvoiceStatus", "Ready For Billing");
      formData.append("InvoiceNo", invoiceNo);
      formData.append("InvoiceDate", invoiceDate);
      formData.append("InvoiceAmount", finalAmount);
      formData.append("CaseCount", selected.length.toString());
      formData.append("IsGSTApplied", isGSTApplied ? "true" : "false");

      if (uploadedFile) {
        formData.append("Invoice", uploadedFile, uploadedFile.name);
        console.log(uploadedFile, 'upload upload', uploadedFile.name)
      }

      const invoiceWithFile = selected.find((inv) => inv.RemarkFile);
      if (invoiceWithFile && invoiceWithFile.RemarkFile) {
        formData.append(
          "RemarkFile",
          invoiceWithFile.RemarkFile,
          invoiceWithFile.RemarkFile.name
        );
      }

      setLoading(true);
      const response = await fetch(`${BASE_URL}/SaveApprovalBatchData`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      console.log("upload data", result)
      setLoading(false);

      if (!response.ok) {
        throw new Error(
          `Error submitting batch: ${result.message || response.statusText}`
        );
      }
      // toast.success("Batch submitted successfully.");
      localStorage.removeItem("invoices");
      console.log(isGSTApplied, "GSTTTTT", uploadedFile);

      Swal.fire({
        title: "✅ Batch Created Successfully!",
        text: "Your batch has been submitted successfully.",
        icon: "success",
        confirmButtonColor: "#7E00D1",
        confirmButtonText: "OK",
      }).then(() => {
        if (isGSTApplied && !uploadedFile) {
          navigate("/invoice");
        } else {
          navigate("/approval");
        }
      });

    } catch (error) {
      console.error("Submission failed:", error);
      setLoading(false);
      toast.error("Submission failed. Please check console for details.");
    }
  };

  const fetchInvoiceNumber = async () => {
    try {
      const res = await fetch(`${BASE_URL}/GetInvoiceNumber?id=${vendorId}`);
      const data = await res.json();
      console.log("invoice data", data)
      if (data.status && data.invoiceNumber) {
        setInvoiceNo(data.invoiceNumber);
        setInvoiceExists(false);
      } else {
        toast.error("Failed to get invoice number");
      }
    } catch (error) {
      console.error("Invoice number API error:", error);
      toast.error("Error generating invoice number");
    }
  };
  const checkDuplicateInvoice = async (value) => {
    try {
      const res = await fetch(`${BASE_URL}/InvoiceCheck`);
      const data = await res.json();

      if (data?.status && Array.isArray(data.invoices)) {
        const isDuplicate = data.invoices.some(inv => inv.invoiceNumber === value);
        setInvoiceExists(isDuplicate);
      }
    } catch (error) {
      console.error("InvoiceCheck API error:", error);
      toast.error("Error checking invoice duplicity");
    }
  };

  const formatDate = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") return "--";

    // if it’s an Excel serial date accidentally passed as a number string, try converting
    if (!isNaN(dateTimeStr)) {
      const serial = parseFloat(dateTimeStr);
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      return date_info.toLocaleDateString("en-GB"); // DD/MM/YYYY
    }

    const [datePart] = dateTimeStr.split(" ");
    if (!datePart.includes("-")) return "--";

    const [day, month, year] = datePart.split("-");
    if (!day || !month || !year) return "--";

    return `${day}/${month}/${year}`;
  };

  return (
    <div
      className="container py-4"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="card shadow-sm p-4">
        <div
          className="d-flex justify-content-between align-items-center mb-4"
          style={{
            backgroundColor: "#e6f0ff",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h2 className="mb-0">Upload Invoice</h2>
          <button
            className="btn btn-primary d-flex align-items-center"
            style={{
              backgroundColor: "#8000d7",
              border: "none",
              padding: "10px 16px",
              borderRadius: "8px",
              fontWeight: "500",
              fontSize: "14px",
            }}
            // onClick={() => navigate(-1)}
            onClick={handleBackClick}
          >
            Back
          </button>
        </div>

        <div className="netwrok_table_main_content">
          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
            <div className="d-flex flex-wrap gap-2 align-items-center">
              <div className="fw-semibold">
                <span>Vendor: </span>
                <span className="text-success">{vendorName}</span>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
                onClick={handleClick}
              >
                <FaUpload /> <span className="ms-2">Upload Invoice</span>
              </button>
              {/* <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
                accept="*"
              /> */}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
                accept=".pdf,.jpg,.jpeg,.png"
              />

            </div>
          </div>
          {fileType && uploadedFile && (
            <div className="text-end upload_file_ext_name mb-3">
              <span className="fw-bold text-success" style={{ cursor: "pointer" }} onClick={() => window.open(URL.createObjectURL(uploadedFile), "_blank")}>
                {uploadedFile.name}
              </span>

              {fileType === "pdf" ? (
                <img
                  src={pdfimage}
                  alt="PDF Icon"
                  style={{ width: "24px", height: "24px", marginLeft: "10px" }}
                />
              ) : fileType === "image" ? (
                <img
                  src={URL.createObjectURL(uploadedFile)}
                  alt="Image Preview"
                  style={{ width: "50px", height: "50px", marginLeft: "10px", objectFit: "cover", borderRadius: "4px" }}
                />
              ) : null}
            </div>
          )}

          <div
            className="table-container mt-3"
            style={{ overflowX: "auto", maxHeight: "400px", overflowY: "auto" }}
          >
            <Table className="table-auto bg-white text-center border-dark network_table">
              <thead
                style={{
                  backgroundColor: "#EEF4FF",
                  position: "sticky",
                  top: "0",
                  zIndex: "1",
                }}
              >
                <tr className="text-dark fw-semibold table_th_border">
                  <th className="border-start">Select</th>
                  <th className="border-start">View</th>
                  <th className="border-start">Validate</th>
                  <th className="border-end border-start" style={{ whiteSpace: "nowrap" }}>
                    Action
                  </th>
                  <th style={{ whiteSpace: "nowrap" }}>AA Number</th>
                  <th style={{ whiteSpace: "nowrap" }}>IMEI Number</th>
                  <th style={{ whiteSpace: "nowrap" }}>Creation Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Closure Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Selling Partner</th>
                  <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                  <th style={{ whiteSpace: "nowrap" }}>Service Type</th>
                  <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                  <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                  <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                  <th style={{ whiteSpace: "nowrap" }}>Logistics and Repair Support Fees(Pre GST)</th>
                  <th style={{ whiteSpace: "nowrap" }}>Total</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                  <th style={{ whiteSpace: "nowrap" }}>Mismatched Data</th>
                  <th style={{ whiteSpace: "nowrap" }}>Differences</th>
                  {/* <th style={{ whiteSpace: "nowrap" }}>Remarks</th>
                  <th style={{ whiteSpace: "nowrap" }}>Remark File</th> */}
                  <th style={{ whiteSpace: "nowrap" }}>Document</th>
                  <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                    Billing Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="20" className="text-center py-3">
                      Validating data...
                    </td>
                  </tr>
                )}
                {!loading &&
                  mergedInvoices.map((invoice, index) => (
                    <tr
                      key={invoice.id || `${invoice.aA_Number}-${index}`}
                      className={`text-center border-bottom network_td_item ${getRowClassName(
                        invoice
                      )}`}
                      aria-label={
                        getRowClassName(invoice).replace("row-", "") + " row"
                      }
                    >
                      <td className="border-start align-middle">
                        <Form.Check
                          type="checkbox"
                          checked={invoice.isChecked}
                          onChange={() =>
                            handleCheckboxChange(invoice.aA_Number)
                          }
                        />
                      </td>
                      <td className="border-start align-middle">
                        <FaEye
                          size={25}
                          className="text-purple-600 review_fa_eye"
                          style={{ cursor: "pointer" }}
                          // onClick={() =>
                          //   navigate("/invoice-template", {
                          //     state: { aaNumber: invoice.aA_Number },
                          //   })
                          // }
                          onClick={() => handleViewClick(invoice.aA_Number)}
                        />
                      </td>
                      <td className="border-start align-middle">
                        <FaEdit
                          size={25}
                          className="text-blue-600 review_fa_eye"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditClick(index, invoice)}
                        />
                      </td>
                      <td
                        className="align-middle border-end pointer-cursor border-start"
                        style={{ cursor: "pointer" }}
                      >
                        <FaTrash
                          onClick={() => handleDelete(invoice.aA_Number)}
                          size={25}
                          style={{ color: "red" }}
                        />
                      </td>
                      <td className="align-middle">
                        {invoice.aA_Number || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.imeiNumber || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.creationDate
                          ? formatDate(invoice.creationDate)
                          : "--"}
                      </td>
                      <td className="align-middle">
                        {invoice.closureDate
                          ? formatDate(invoice.closureDate)
                          : "--"}
                      </td>
                      <td className="align-middle">
                        {invoice.sellingPartner || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.customerName || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.serviceType || "-"}
                      </td>
                      <td className="align-middle">{invoice.brand || "-"}</td>
                      <td className="align-middle">
                        {invoice.makeModel || "-"}
                      </td>
                      <td className="align-middle">
                        {invoice.repairCharges || "0.00"}
                      </td>
                      <td className="align-middle">
                        {invoice.serviceCharges || "0.00"}
                      </td>
                      <td className="align-middle">
                        {invoice.total || "0.00"}
                      </td>
                      <td className="align-middle">
                        <span
                          className="vendore_invoice_status px-2 py-1 rounded-pill"
                          style={{
                            backgroundColor:
                              statusColor[invoice.invoiceStatus?.trim()]?.backgroundColor || "#F3F4F6",

                            color:
                              statusColor[invoice.invoiceStatus?.trim()]?.color || "#6B7280",

                            border: `1px solid ${statusColor[invoice.invoiceStatus?.trim()]?.color || "#6B7280"
                              }`,

                            fontSize: "13px",
                            padding: "8px 14px",
                            fontWeight: "600",
                          }}
                        >
                          {invoice.invoiceStatus?.trim() || "Ready For Billing"}
                        </span>
                      </td>
                      <td className="align-middle">
                        {getDifferencesData(invoice).length > 0
                          ? "Mismatch"
                          : "Valid"}
                      </td>
                      <td
                        className="align-middle position-relative"
                        onMouseEnter={() => setHoveredRow(index)}
                        onMouseLeave={() => setHoveredRow(null)}
                        style={{ cursor: "pointer", position: "relative" }}
                      >
                        {getDifferencesData(invoice).length > 0
                          ? "View Details"
                          : "-"}
                        {hoveredRow === index &&
                          getDifferencesData(invoice).length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: "-18%",
                                transform: "translateX(-50%)",
                                zIndex: 1000,
                                backgroundColor: "#fff",
                                border: "1px solid #ddd",
                                padding: "10px",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                minWidth: "300px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <table className="table table-sm table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th>Field</th>
                                    <th>Excel Data</th>
                                    <th>System Data</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {getDifferencesData(invoice).map(
                                    (diff, i) => (
                                      <tr key={i}>
                                        <td>{diff.field}</td>
                                        <td>{diff.table}</td>
                                        <td>{diff.api}</td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                      </td>
                      {/* <td className="align-middle">
                        {invoice.remarks || "No remark"}
                        {getRowClassName(invoice) === "row-yellow" &&
                          !invoice.remarks && (
                            <span className="text-danger ms-1">*</span>
                          )}
                      </td>
                      <td className="align-middle border-end">
                        {invoice.remarkFileUrl ? (
                          <a
                            href={invoice.remarkFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#8000d7",
                              textDecoration: "underline",
                            }}
                          >
                            View File
                          </a>
                        ) : (
                          "-"
                        )}
                      </td> */}
                      <td className="align-middle">
                        {invoice.documentFileUrl ? (
                          <a
                            href={invoice.documentFileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#8000d7",
                              textDecoration: "underline",
                              whiteSpace: "nowrap",
                            }}
                          >
                            View PDF
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td className="align-middle border-end">
                        {invoice.billingType || "-"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <Modal show={openRemarkModal} onHide={() => setOpenRemarkModal(false)} centered size="md">
            <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
              <Modal.Title>Add Remark</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    placeholder="Enter remark"
                  />
                </Form.Group>

                {/* <Form.Group className="mb-3" controlId="remarkFile">
                  <Form.Label
                    className="btn btn-secondary mb-0"
                    style={{ backgroundColor: "#8000d7", border: "none" }}
                    onClick={() => fileInputRef.current.click()}
                  >
                    Upload File
                  </Form.Label>
                  <Form.Control
                    type="file"
                    onChange={(e) => setRemarkFile(e.target.files[0])}
                    style={{ display: "none" }}
                    ref={fileInputRef}
                    accept="application/pdf"
                  />
                  {remarkFile && (
                    <div className="mt-2 text-muted">Selected File: {remarkFile.name}</div>
                  )}
                </Form.Group> */}
              </Form>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setOpenRemarkModal(false)}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleRemarkSubmit}
                style={{ backgroundColor: "#8000d7", border: "none" }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
          <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
            <button
              className="btn btn-outline-primary"
              onClick={handlePrevious}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span className="page-info">
              {Math.min(currentPage * itemsPerPage, invoices.length)} out of {invoices.length}
            </span>

            <button
              className="btn btn-outline-primary"
              onClick={handleNext}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
          <div className="row justify-content-between align-items-center mt-2">
            <div className="col-12">
              <div className="border rounded p-2 mt-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="fw-bold ms-2">
                    <span>GST</span>
                  </div>
                  <div className="d-flex gap-3">
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === true}
                        onChange={() => setIsGSTApplied(true)}
                        disabled={false}
                      />
                      <span className="registration_applied_yes">Yes</span>
                    </label>
                    <span className="mx-1">/</span>
                    <label className="registration_kc_radio">
                      <input
                        type="radio"
                        name="gstApplied"
                        checked={isGSTApplied === false}
                        onChange={() => setIsGSTApplied(false)}
                        disabled={isNoDisabled}
                      />
                      <span className="registration_applied_yes">No</span>
                    </label>
                  </div>
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#eef4ff",
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  padding: "5px",
                  whiteSpace: "nowrap",
                }}
              >
                <span style={{ fontWeight: 600, color: "gray" }}>
                  Total no of selected Service:
                </span>
                <span style={{ fontWeight: "bold", color: "black" }}>
                  {selectedAAno.length}
                </span>
              </div>


              <div
                className="batch_popup_gross_ammount mt-2 w-100"
                style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}
              >
                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Repair Charges</div>
                  <div className="text-end batch_amount_to_fix">
                    ₹ {totalRepairCharges.toFixed(2)}
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Total Logistics and Repair Support Fees</div>
                  <div className="d-flex align-items-center">
                    <div className="batch_amount_to_fix">
                      ₹ {totalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between batch_popup_amount">
                  <div className="fw-bold batch_gross">Final Amount</div>
                  <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}><b>₹ {finalAmount}</b></div>
                </div>

                <div className="mt-2 d-flex justify-content-end">
                  <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                    {isGSTApplied
                      ? `GST Amount Added: ₹${gstAmount}`
                      : `No GST Applied (₹${gstAmount})`}
                  </span>
                </div>
              </div>


            </div>
          </div>

          <div className="d-flex mt-4 justify-content-center align-items-center flex-wrap gap-3">
            <button
              onClick={downloadCSV}
              className="btn btn-primary d-flex align-items-center"
              style={{
                backgroundColor: "rgb(248, 238, 255)",
                border: "1px solid #8000d7",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "#8000d7",
              }}
            >
              <FaDownload /> <span className="ms-2">Download</span>
            </button>
            <button
              className="btn btn-primary d-flex align-items-center"
              onClick={handleSubmit}
              disabled={loading}
              style={{
                backgroundColor: "#8000d7",
                border: "none",
                padding: "10px 50px",
                borderRadius: "8px",
                fontWeight: "500",
                fontSize: "16px",
                color: "white",
              }}
            >
              {loading ? "Processing..." : "Confirm"}
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="xl">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoice (AA Number: {editingInvoice?.aA_Number || "-"})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {/* Left Side: Form Controls */}
            <div className="col-md-5 border-end">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Billing Type</Form.Label>
                  <Form.Select
                    name="billingType"
                    value={editedCharges.billingType}
                    onChange={handleEditInputChange}
                    size="lg"
                  >
                    <option value="billing">Billing</option>
                    <option value="reimbursement">Reimbursement</option>
                  </Form.Select>
                </Form.Group>
                {editedCharges.billingType === "reimbursement" ? (
                  <Alert variant="info" className="mb-3">
                    <strong>Reimbursement Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>Repair Charges → Reimbursement Challan</li>
                      <li>Service Charges → Service Invoice</li>
                    </ul>
                  </Alert>
                ) : (
                  <Alert variant="info" className="mb-3">
                    <strong>Billing Mode:</strong>
                    <ul className="mb-0 mt-2">
                      <li>
                        Single Invoice will be generated for total amount (
                        Repair Charges + Service Charges)
                      </li>
                    </ul>
                  </Alert>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Repair Charges</Form.Label>
                  <Form.Control
                    type="number"
                    name="repairCharges"
                    value={editedCharges.repairCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    size="lg"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Logistics and Repair Support Fees</Form.Label>
                  <Form.Control
                    type="number"
                    name="serviceCharges"
                    value={editedCharges.serviceCharges}
                    onChange={handleEditInputChange}
                    min="0"
                    step="0.01"
                    placeholder="0.00"
                    size="lg"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="remarks"
                    value={editedCharges.remarks}
                    onChange={handleEditInputChange}
                    placeholder="Enter remark"
                    className={
                      fieldErrors.remarks?.[editingInvoice?.aA_Number]
                        ? "is-invalid"
                        : ""
                    }
                  />
                  {fieldErrors.remarks?.[editingInvoice?.aA_Number] && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      Remarks are required for mismatched data.
                    </div>
                  )}
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFile">
                  <Form.Label
                    className="btn btn-secondary mb-0"
                    style={{ backgroundColor: "#8000d7", border: "none" }}
                    onClick={() => modalFileInputRef.current.click()}
                  >
                    Upload File
                  </Form.Label>

                  <Form.Control
                    type="file"
                    id="fileUpload"
                    name="file"
                    onChange={handleModalFileChange}
                    style={{ display: "none" }}
                    ref={modalFileInputRef}
                  />

                  {editedCharges.fileName && (
                    <div className="mt-2 d-flex align-items-center">
                      <span className="text-muted me-2">
                        Selected File: {editedCharges.fileName}
                      </span>
                      {editedCharges.file &&
                        editedCharges.file.type === "application/pdf" && (
                          <Button
                            variant="link"
                            className="p-0 ms-2"
                            onClick={() => setShowPreview(!showPreview)}
                            style={{ fontSize: "14px", color: "#8000d7" }}
                          >
                            <FaEye className="me-1" />{" "}
                            {showPreview ? "Hide Preview" : "Show Preview"}
                          </Button>
                        )}
                    </div>
                  )}

                  {showPreview &&
                    editedCharges.file &&
                    editedCharges.file.type === "application/pdf" && (
                      <div
                        className="mt-3"
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          overflow: "hidden",
                        }}
                      >
                        <iframe
                          src={URL.createObjectURL(editedCharges.file)}
                          style={{ width: "100%", height: "400px", border: "none" }}
                          title="PDF Preview"
                          onLoad={() => {
                            setTimeout(
                              () =>
                                URL.revokeObjectURL(
                                  URL.createObjectURL(editedCharges.file)
                                ),
                              10000
                            );
                          }}
                        />
                      </div>
                    )}
                </Form.Group>
              </Form>
            </div>

            {/* Right Side: Document Preview & Downloads */}
            <div className="col-md-7 d-flex flex-column" style={{ minHeight: "550px" }}>
              <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                <span className="fw-bold text-dark" style={{ fontSize: "16px" }}>Document Live Preview</span>
                {editedCharges.billingType === "reimbursement" && (
                  <div className="d-flex gap-2">
                    <Button
                      variant={activePreviewTab === "challan" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("challan")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Challan (Repair)
                    </Button>
                    <Button
                      variant={activePreviewTab === "invoice" ? "primary" : "outline-primary"}
                      onClick={() => setActivePreviewTab("invoice")}
                      size="sm"
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Logistics Invoice (Logistics)
                    </Button>
                  </div>
                )}
              </div>

              {/* Scrollable Preview Frame */}
              <div className="flex-grow-1 overflow-auto border rounded bg-light p-2 mb-3" style={{ maxHeight: "500px" }}>
                {renderDocumentPreview()}
              </div>

              {/* Download buttons bar */}
              <div className="d-flex gap-2 justify-content-end align-items-center border-top pt-2">
                <span className="text-muted me-auto" style={{ fontSize: "11px" }}>
                  * Preview shows dynamic data based on inputs & API response.
                </span>
                {editedCharges.billingType === "billing" ? (
                  <Button
                    variant="success"
                    onClick={() => downloadInvoicePDF(editingInvoice, [...getDisplayItems().repair, ...getDisplayItems().service])}
                    size="sm"
                    className="d-flex align-items-center gap-1"
                    style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                  >
                    <FaDownload /> Download Tax Invoice
                  </Button>
                ) : (
                  <>
                    <Button
                      variant="success"
                      onClick={() => downloadChallanPDF(editingInvoice, getDisplayItems().repair)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Challan
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => downloadInvoicePDF(editingInvoice, getDisplayItems().service)}
                      size="sm"
                      className="d-flex align-items-center gap-1"
                      style={{ backgroundColor: "#28a745", borderColor: "#28a745" }}
                    >
                      <FaDownload /> Download Logistics Invoice
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveEdit}
            style={{
              backgroundColor: "#8000d7",
              border: "none",
            }}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .tooltip {
          position: relative;
          display: inline-block;
        }
        .tooltip:hover .tooltiptext {
          visibility: visible;
          opacity: 1;
        }
        .row-red {
          background-color: #ffe6e6;
          color: #d32f2f;
        }
        .row-yellow {
          background-color: #fff9c4;
        }
        .row-green {
          background-color: #fff;
        }
        .table-container {
          max-height: 400px;
          overflow-y: auto;
          overflow-x: auto;
        }
        .network_table {
          width: max-content;
          min-width: 100%;
        }
        .network_table th,
        .network_table td {
          overflow-wrap: break-word;
          padding: 8px 10px;
          vertical-align: middle;
          min-width: 80px;
        }
        .vendore_invoice_status {
          display: inline-block;
          white-space: nowrap;
        }
        .pagination-container {
          margin-top: 1rem;
        }
        .page-info {
          font-weight: 500;
        }
        .batch_popup_gross_amount {
          border-radius: 4px;
        }
        .batch_popup_amount {
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};

export default VendorBatchPage;
